import cx from "classnames"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { SIGNUP_URL } from "constants/urls"
import ContactSalesModal from "components/ContactSalesModal"
import { openModal } from "utils/openModal"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import CTA from "components/ui/CTA"
import Heading from "components/ui/Heading"
import Image from "components/ui/Image"

function DoubleCTASection({
  className,
  noBackground,
  noHeading,
  trackingName,
}) {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const { getAsset } = usePageAssets()
  const ctaSectionBackground = getAsset("double-cta-section-bg-svg")
  const ctaDarkBackground = getAsset("double-cta-bg-dark-svg")
  const ctaLightBackground = getAsset("double-cta-bg-light-svg")
  return (
    <section
      className={cx(className, { "relative pb-10 md:pb-48": !noBackground })}
    >
      {!noBackground && (
        <div className="absolute bottom-0 right-0 max-h-full w-full">
          <Image
            className="object-top-right w-full object-contain"
            src={ctaSectionBackground}
          />
        </div>
      )}
      <Container className="relative z-10">
        {!noHeading && (
          <Heading
            className="mb-14"
            label="Try Preset for Free"
            title="Turn every team into a data team with Preset"
            decoration="line"
          />
        )}
        <div className="grid grid-cols-1 gap-x-16 gap-y-7 lg:grid-cols-2">
          <CTA
            background={ctaDarkBackground}
            label="Get Started"
            title={
              <>
                Ready to give Preset a try?
                <br className="hidden sm:block" /> Get up and running in
                minutes.
              </>
            }
            linkText="Try for free"
            linkUrl={SIGNUP_URL}
            trackClick={`Try for free (cta)_${trackingName}`}
            svgBackground
            dark
          />
          <CTA
            background={ctaLightBackground}
            label="For Enterprises"
            title={
              <>
                Do you need a custom solution?{" "}
                <br className="hidden sm:block" /> Reach out for consultation.
              </>
            }
            linkText="Talk to an Expert"
            linkUrl="/contact-sales/"
            onButtonClick={openModal(setIsContactModalOpen)}
            trackClick={`Contact sales (cta)_${trackingName}`}
            svgBackground
          />
        </div>
      </Container>
      <ContactSalesModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        sourcePage={`${trackingName} - CTA`}
      />
    </section>
  )
}

DoubleCTASection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
  /** If true, doesn't show section background illustration */
  noBackground: PropTypes.bool,
  /** If true, doesn't show heading section on top of CTAs */
  noHeading: PropTypes.bool,
  /** Tracking namespace - if set, the signup click / submit events will be scoped to this name */
  trackingName: PropTypes.string,
}

export default DoubleCTASection
